import { mergeMap, map, catchError } from 'rxjs/operators'
import { of, from } from 'rxjs'
import * as actions from './actions'
import { ofType } from 'redux-observable'
import { rootCatchError } from '../../lib/Utils'

let analytics

export const initializeAnalytics = (action$) => {
  return action$.pipe(
    ofType(actions.INITIALIZE_ANALYTICS),
    mergeMap((action) => {
      if (action.payload && action.payload.analytics) {
        analytics = action.payload.analytics
      } else {
        return of({
          type: actions.INITIALIZE_ANALYTICS_REJECTED,
          payload: {
            error: 'No analytics object provided',
          },
        })
      }

      return of({
        type: actions.INITIALIZE_ANALYTICS_FULFILLED,
      })
    }),
    catchError((payload) => {
      return of({
        type: actions.INITIALIZE_ANALYTICS_REJECTED,
        payload,
      })
    }),
  )
}

export const analyticsIdentifyUser = (action$) => {
  return action$.pipe(
    ofType(actions.ANALYTICS_IDENTIFY_USER),
    mergeMap((action) => {
      const { userId, traits = {}, options = {} } = action.payload
      if (analytics) {
        let identifyComplete
        const promise = new Promise((resolve) => {
          identifyComplete = resolve
        })
        analytics.identify(userId, traits, options, function() {
          identifyComplete()
        })
        return from(promise).pipe(
          map(function() {
            return {
              type: actions.ANALYTICS_IDENTIFY_USER_FULFILLED,
              payload: {
                userId,
                traits,
                options,
              },
            }
          }),
          catchError(function(error) {
            return of({
              type: actions.ANALYTICS_IDENTIFY_USER_REJECTED,
              payload: error,
            })
          }),
        )
      } else {
        throw new Error('Analytics has not been initialized')
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.ANALYTICS_IDENTIFY_USER_REJECTED,
        payload,
      })
    }),
  )
}

export const track = (action$) => {
  return action$.pipe(
    ofType(actions.TRACK),
    mergeMap((action) => {
      const eventName = (action.payload && action.payload.event) || action.type
      const eventPayload =
        (action.payload && action.payload.data) || action.payload

      if (analytics) {
        analytics.track(eventName, eventPayload)
        return of({
          type: actions.TRACK_FULFILLED,
        })
      } else {
        return of({
          type: actions.TRACK_REJECTED,
        })
      }
    }),
    catchError((payload) => {
      return of({
        type: actions.TRACK_REJECTED,
        payload,
      })
    }),
  )
}

export const group = (action$) => {
  return action$.pipe(
    ofType(actions.GROUP),
    mergeMap((action) => {
      const { groupId, traits = {} } = action.payload || {}
      
      if (!groupId) {
        throw new Error('groupId is required')
      }

      if (analytics) {
        analytics.group(groupId, traits)
        return of({
          type: actions.GROUP_FULFILLED,
        })
      } else {
        return of({
          type: actions.GROUP_REJECTED,
        })
      }
    }),
    rootCatchError(actions.GROUP_REJECTED),
  )
}
